import { checkEmail } from './Rules'

export default {
    contactName: [{ required: true, message: window.i18n.__('Veuillez renseigner un nom valide'), trigger: 'blur' }],
    contactMailAddress: [
        { required: true, message: window.i18n.__('Veuillez renseigner une adresse email valide'), trigger: 'blur' },
        { validator: checkEmail, trigger: 'blur' },
    ],
    contactPhone: [{ required: true, message: window.i18n.__('Veuillez renseigner un numéro de téléphone valide'), trigger: 'blur' }],
}